import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=361db11f&"
import script from "./CloseIcon.vue?vue&type=script&lang=js&"
export * from "./CloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports